import React from 'react';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { queryClient } from './react-query/queryClient';
import { ToastContainer } from 'react-toastify';
import env from './environment_system/env_system';
import { BrowserRouter as BRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import './index.css';
import App from './App';
import { configureStore } from './Store';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const store = configureStore({});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

const AppWrapper = (
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
        <BRouter basename={env.base_name}>
          <App />
        </BRouter>
    </Provider>
    <ToastContainer />
    <ReactQueryDevtools />
  </QueryClientProvider>
);

root.render(
  env.enable_strict_mode ? (
    <React.StrictMode>{AppWrapper}</React.StrictMode>
  ) : (
    AppWrapper
  )
);
